import LaunchIcon from "@mui/icons-material/Launch";
import {
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Page from "../components/Page";
import { formatTime } from "../components/Time";
import type { BusinessPacket } from "../data/business";
import { useBusinesses } from "../data/business";

function Home() {
  const businesses = useBusinesses();

  return (
    <Page title="Businesses">
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>GSTIN</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Created At</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>
                Token Expires At
              </TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Data Expires At</TableCell>
              <TableCell sx={{ fontWeight: "bold" }}>Go To</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {businesses?.map((business: BusinessPacket) => (
              <TableRow key={business.id}>
                <TableCell>{business.gstin}</TableCell>
                <TableCell>{business.status}</TableCell>
                <TableCell>
                  {business.createdAt ? formatTime(business.createdAt) : "-"}
                </TableCell>
                <TableCell>
                  {business.tokenExpiresAt
                    ? formatTime(business.tokenExpiresAt)
                    : "-"}
                </TableCell>
                <TableCell>
                  {business.dataExpiresAt
                    ? formatTime(business.dataExpiresAt)
                    : "-"}
                </TableCell>
                <TableCell>
                  <Link href={`/business/${business.gstin}`}>
                    <LaunchIcon />
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Page>
  );
}

export default Home;
